import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { initialFilter } from "../contexts/AdminContext";
import { DATATYPE_DOCUMENT, DATATYPE_SYSTEM, FileName, FileName2, TITLE } from "../databases/spName";
import BlockContainer from "../components/BlockContainer";
import { SelectForm } from "../components/FormItem";
import { saveAs } from 'file-saver'
import { onDownloadFileClick } from "../databases/files";
import { GetDataFromFirebase, QueryUsersWithFilter } from "../databases/users";

const PageDownload = () => {

    const initialChecked = useMemo(() => {
        let a = {}
        Object.keys({...TITLE}).filter(v => ![DATATYPE_DOCUMENT, DATATYPE_SYSTEM].includes(TITLE[v].datatype)).forEach(keyname => {
            a = {...a, [keyname] : false }
        })
        return a
    }, [])
    const [checkedItems, setCheckedItems] = useState(initialChecked)
    const [filter, setFilter] = useState({...initialFilter})
    const [selectRound, setSelectRound] = useState(0)
    const [selectFile, setSelectFile] = useState('')

    const [onLoading, setOnLoading] = useState(false)
    const stopRef = useRef(false)

    useEffect(() => {
        return () => {
            setSelectFile('')
            setSelectRound(0)
            setOnLoading(false)
        }
    }, [])

    const filterOptions = useMemo(() => {
        let a = {'' : ''}
        Object.keys({...TITLE}).filter(v => ![DATATYPE_DOCUMENT, DATATYPE_SYSTEM].includes(TITLE[v].datatype)).forEach(keyname => {
            a = {...a, [keyname] : TITLE[keyname].TH + ' / ' + TITLE[keyname].CN }
        })
        return a
    }, [])

    

    const onDownloadDataClick = async () => {
        try {
            setOnLoading(true)
            let s = ''
            let rows = await GetDataFromFirebase(filter, checkedItems)
            let keyArray = [...Object.keys(checkedItems).filter(v => checkedItems[v] === true)]
            let header = keyArray.map(v => TITLE[v].CN || TITLE[v].TH).join(',')
            s += header + '\n'
            if (keyArray.includes('flightIndex')) rows = rows.sort((x, y) => {
                let ix = x.flightIndex
                let iy = y.flightIndex
                if (isNaN(ix)) return 1
                if (isNaN(iy)) return -1
                return parseInt(ix) > parseInt(iy) ? 1 : parseInt(ix) < parseInt(iy) ? -1 : 0
            })
            for (let i = 0; i < rows.length; i++) {
                for (let j = 0; j < keyArray.length; j++) {
                    let u = {...rows[i]}
                    let k = keyArray[j]
                    if (TITLE[k].options && typeof TITLE[k].options === 'object' && TITLE[k].options[u[k]]) {
                        u[k] = TITLE[k].options[u[k]]
                    }
                    s += (u[k] || '') + ','
                }
                s += '\n'
            }
            const blob = new Blob([s], { type: 'text/csv;charset=utf-8;' });
            saveAs(blob, '123.csv')
        }
        catch (e) {
            console.log(e)
        }
        finally {
            setOnLoading(false)
        }
    }

    const onDownloadAllClick = async () => {
        const delay = ms => new Promise(r => setTimeout(() => r(), ms))
        setOnLoading(true)
        try {
            let users = await QueryUsersWithFilter({    
                0 : { field : 'round', value : selectRound },
                1 : { field : selectFile, value : true },
                2 : { field : '-', value : '' }
            })
            console.log(Object.values(users)[0])
            if (users) {
                for (const keyname in users) {
                    if (users[keyname][selectFile] && users[keyname].round === selectRound) {
                        const user = users[keyname]
                        const fileName = `${user.flightIndex ? user.flightIndex + ' ' : ''}${user.nameEN}`
                        await onDownloadFileClick(`${keyname}/${FileName[selectFile]}`, fileName)
                        await delay(10)
                    }
                    if (stopRef.current) {
                        break;
                    }
                    
                }
            }
        }
        catch (e) {
            console.log(e)
        }
        finally {
            console.log('fin')
            setOnLoading(false)
            stopRef.current = false
        }
        
    }

    return (
        <div>
            <div className="bold" style={{whiteSpace : 'break-spaces'}}>{`ฟิลเตอร์`}</div>
            <BlockContainer>
            <Row bsPrefix='row align-items-center text-center'>
                {[0, 1, 2].map((index) => (
                    <Col key={index} md={4} sm={12} xs={12}>
                        <Row bsPrefix='row align-items-center text-center mb-2'>
                            <Col bsPrefix='col-1'>{index + 1}.</Col>
                            <Col>
                                <SelectForm noMargin={true} value={filter[index].field} options={filterOptions} onChange={e => setFilter(f => ({...f, [index] : {...f[index], field : e.target.value}}))} />
                            </Col>
                            <Col>
                                <Form.Control value={filter[index].value} onChange={e => setFilter(f => ({...f, [index] : {...f[index], value : e.target.value}}))} />
                            </Col>
                        </Row>
                    </Col>
                ))}
            </Row>
            </BlockContainer>
            <br /><br />
            
            <div className="bold">หัวตาราง เอาฟิลด์อะไรบ้าง : </div>
            <BlockContainer>
                
                <Row>
                    {Object.keys({...initialChecked}).map((keyname, index) => (
                        <Col key={index} xs={12} sm={6} md={4} lg={3} xl={2}>
                            <Form.Check 
                                checked={checkedItems[keyname]} label={TITLE[keyname].CN || TITLE[keyname].TH} id={`tablebuilder-${keyname}`}
                                onChange={e => setCheckedItems(i => ({...i, [keyname] : e.target.checked }))} 
                            />
                        </Col>
                    ))}
                    
                </Row>
                <Button onClick={onDownloadDataClick} disabled={onLoading}>
                    {onLoading ? <Spinner animation="border" size='sm' /> : <></>}ดาวน์โหลดตาราง
                </Button>
            </BlockContainer>

            <br /><hr /><br />
            <div className="bold">ไฟล์</div>
            <BlockContainer>
                <Row bsPrefix="row align-items-center">
                    <Col bsPrefix="col-auto"><div className="bold">เที่ยวบิน</div></Col>
                    <Col bsPrefix="col-auto">
                        <SelectForm noMargin={true} value={selectRound} onChange={e => setSelectRound(parseInt(e.target.value))} options={TITLE.round.options}/>
                    </Col>
                    <Col bsPrefix="col-auto"><div className="bold">เอกสาร</div></Col>
                    <Col bsPrefix="col-auto">
                        <SelectForm noMargin={true} value={selectFile} onChange={e => setSelectFile(e.target.value)} options={{'' : '', ...FileName2}}/>
                    </Col>
                    <Col bsPrefix="col-auto">
                        <Button hidden={selectRound === 0 || selectFile === ''} disabled={onLoading} onClick={onDownloadAllClick}>
                            {onLoading ? <Spinner animation="border" size='sm' /> : <></>}    ปุ่มต้องห้าม
                        </Button>
                    </Col>
                    <Col bsPrefix="col-auto">
                        <Button variant='danger' hidden={selectRound === 0 || selectFile === ''} disabled={!onLoading} onClick={() => stopRef.current = true}>
                            หยุดการดาวน์โหลด!
                        </Button>
                    </Col>
                </Row>
                
            </BlockContainer>
            <br /><br /><br /><br />
        </div>
    )
}

export default PageDownload;